import React from "react";
import { signatureProjects } from "../mock/mock";
import { ArrowUpRight } from "lucide-react";

const Projects = () => {
  return (
    <section id="projects" className="py-24 lg:py-32 bg-ivory-100/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-bronze" />
              <span className="text-[11px] uppercase tracking-[0.3em] text-ink/60">
                Signature Projects
              </span>
            </div>
            <h2 className="font-serif-display text-4xl lg:text-5xl text-ink leading-[1.05] font-light">
              Programs that moved numbers, markets and careers.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-ink/65 leading-relaxed">
              A selection of the engagements I am most proud of — not because of their size alone,
              but because of the organisational change they enabled.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {signatureProjects.map((p, i) => (
            <article
              key={p.id}
              className="lift-card group relative bg-ivory-50 border border-ink/10 p-8 rounded-sm"
            >
              <div className="flex items-start justify-between mb-6">
                <span className="text-[11px] uppercase tracking-[0.22em] text-bronze font-medium">
                  {p.tag}
                </span>
                <ArrowUpRight className="h-5 w-5 text-ink/30 group-hover:text-bronze group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
              </div>

              <div className="font-serif-display text-2xl text-ink leading-tight mb-4">
                {p.title}
              </div>

              <p className="text-[14px] text-ink/70 leading-relaxed">{p.description}</p>

              <div className="mt-8 pt-5 border-t border-ink/10 flex items-center justify-between">
                <span className="text-[11px] uppercase tracking-[0.22em] text-ink/45">
                  Case · 0{i + 1}
                </span>
                <span className="h-px w-8 bg-bronze/40 group-hover:w-16 group-hover:bg-bronze transition-all" />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
